import { RESPONSIVE_QUERIES } from "./responsive-queries";
import { useMediaQuery } from "./useMediaQuery";

export const usePrefersReducedMotion = (): boolean =>
  useMediaQuery(RESPONSIVE_QUERIES.reducedMotion, true);
